import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SocialWidget from '../Widget/SocialWidget';
import Newsletter from '../Widget/Newsletter';
import IconBoxStyle11 from '../IconBox/IconBoxStyle11';
import Spacing from '../Spacing';
import { getUser } from '../../helpers/lib/axios';
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom';
import { IsTokenExpired } from '../../helpers/lib/jwt';

export default function Header({ logoSrc, variant }) {
  const navigate = useNavigate()
  const [isSticky, setIsSticky] = useState(false);
  const [mobileToggle, setMobileToggle] = useState(false);
  const [sideNav, setSideNav] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const token = Cookies.get('noohraToken')
    if (!token) {
      return;
    }
    if (IsTokenExpired(token)) {
      Cookies.remove("noohraToken");
      setUser(null)
      return;
    } else {
      getUser().then(user => {
        setUser(user?.data);
      }).catch(err => console.log(err))
    }
  }, [])

  const handleLogOut = () => {
    Cookies.remove("noohraToken");
    setUser(null)
    navigate('/')
  }

  const linkClass = "text-[0.8rem] font-medium tracking-[0.12em] uppercase text-charcoal no-underline relative transition-colors duration-200 hover:text-crimson after:absolute after:bottom-[-3px] after:left-0 after:w-0 after:h-px after:bg-crimson after:transition-all after:duration-300 hover:after:w-full";
  const ctaClass = "inline-block bg-crimson text-white px-5 py-2.5 rounded-[2px] tracking-[0.1em] text-[0.75rem] font-medium transition-colors duration-200 hover:bg-crimson-dark uppercase whitespace-nowrap";

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-[900] bg-[rgba(250,247,242,0.92)] backdrop-blur-[12px] border-b border-[rgba(139,26,26,0.12)] transition-all duration-300 w-full ${isSticky ? 'shadow-sm py-2' : 'py-[1.2rem]'} ${variant}`}
      >
        <div className="w-full">
          <div className="container mx-auto px-6 md:px-16">
            <div className="flex items-center justify-between">
              
              {/* Logo */}
              <div className="flex items-center space-x-12">
                <Link className="flex items-center gap-[0.75rem] no-underline" to="/">
                  <img src={logoSrc} alt="Logo" className='h-[44px] w-auto ojbect-contain' />
                  <span className="font-serif text-[1.05rem] font-medium text-crimson leading-[1.2] max-w-[200px] hidden lg:block">Noohra Integrated<br/>& Allied Services</span>
                </Link>
                
                {/* Desktop Nav */}
                <nav className="hidden xl:flex items-center">
                  <ul className="flex items-center gap-8 list-none m-0 p-0">
                    <li><Link className={linkClass} to="/">Home</Link></li>
                    <li><Link className={linkClass} to="/about">About</Link></li>
                    <li><Link className={linkClass} to="/services">Services</Link></li>
                    <li><Link className={linkClass} to="/contact">Contact</Link></li>
                    <li>
                      <a href="https://noohrawrites.substack.com/" target="_blank" rel="noreferrer" className={linkClass}>Blog</a>
                    </li>
                  </ul>
                </nav>
              </div>
              
              <div className="flex items-center gap-4 xl:gap-6">
                <div className="hidden md:flex items-center gap-4">
                  {user ? (
                    <>
                      <Link className={linkClass} to="/profile">Dashboard</Link>
                      <button onClick={handleLogOut} className={linkClass}>Logout</button>
                    </>
                  ) : (
                    <Link className={linkClass} to="/signup">Sign Up</Link>
                  )}
                  <Link to="/appointments" className={ctaClass}>Book a Session</Link>
                </div>
                
                {/* Hamburger and Toolbox */}
                <div className="flex items-center gap-3">
                  <span
                    className={`cs_menu_toggle xl:hidden cursor-pointer w-8 h-8 flex flex-col justify-center items-center gap-1.5 ${mobileToggle ? 'cs_teggle_active' : ''}`}
                    onClick={() => setMobileToggle(!mobileToggle)}
                  >
                    <span className={`block w-6 h-0.5 bg-crimson transition-all ${mobileToggle ? 'rotate-45 translate-y-2' : ''}`}></span>
                    <span className={`block w-6 h-0.5 bg-crimson transition-all ${mobileToggle ? 'opacity-0' : ''}`}></span>
                    <span className={`block w-6 h-0.5 bg-crimson transition-all ${mobileToggle ? '-rotate-45 -translate-y-2' : ''}`}></span>
                  </span>
                  
                  <button
                    className="text-crimson transition-colors hover:text-crimson-dark"
                    type="button"
                    onClick={() => setSideNav(!sideNav)}
                  >
                    <svg width={28} height={24} viewBox="0 0 35 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.483887 2.46544C0.483887 1.10383 1.14618 0 1.96315 0H33.5208C34.3377 0 35 1.10383 35 2.46544C35 3.82708 34.3377 4.93088 33.5208 4.93088H1.96315C1.14618 4.93088 0.483887 3.82708 0.483887 2.46544Z" fill="currentColor"/>
                      <path d="M0.483887 14.6694C0.483887 13.3074 1.14618 12.2039 1.96315 12.2039H33.5208C34.3377 12.2039 35 13.3074 35 14.6694C35 16.0309 34.3377 17.1348 33.5208 17.1348H1.96315C1.14618 17.1348 0.483887 16.0309 0.483887 14.6694Z" fill="currentColor"/>
                      <path d="M0.483887 26.6267C0.483887 25.2648 1.14618 24.1613 1.96315 24.1613H33.5208C34.3377 24.1613 35 25.2648 35 26.6267C35 27.9883 34.3377 29.0922 33.5208 29.0922H1.96315C1.14618 29.0922 0.483887 27.9883 0.483887 26.6267Z" fill="currentColor"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            
            {/* Mobile Nav */}
            {mobileToggle && (
              <div className="xl:hidden mt-4 pt-4 border-t border-[rgba(139,26,26,0.1)]">
                <ul className="flex flex-col gap-4 list-none m-0 p-0 text-center pb-4">
                  <li onClick={() => setMobileToggle(false)}><Link className={linkClass} to="/">Home</Link></li>
                  <li onClick={() => setMobileToggle(false)}><Link className={linkClass} to="/about">About</Link></li>
                  <li onClick={() => setMobileToggle(false)}><Link className={linkClass} to="/appointments">Bookings</Link></li>
                  <li onClick={() => setMobileToggle(false)}><Link className={linkClass} to="/services">Services</Link></li>
                  <li onClick={() => setMobileToggle(false)}><Link className={linkClass} to="/contact">Contact</Link></li>
                  <li onClick={() => setMobileToggle(false)}>
                    {user ? (
                      <div className="flex flex-col gap-3">
                        <Link className={linkClass} to="/profile">Dashboard</Link>
                        <button onClick={() => { handleLogOut(); setMobileToggle(false); }} className={linkClass}>Logout</button>
                      </div>
                    ) : (
                      <Link className={linkClass} to="/signup">Sign Up</Link>
                    )}
                  </li>
                  <li onClick={() => setMobileToggle(false)} className="mt-2">
                    <Link to="/appointments" className={ctaClass}>Book a Session</Link>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </header>
      
      {/* Side Nav Content */}
      <div className={`fixed inset-0 z-[1000] flex transition-all duration-300 ${sideNav ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}>
        <div
          className="absolute inset-0 bg-charcoal/80 transition-opacity"
          onClick={() => setSideNav(false)}
        />
        <div className={`absolute top-0 right-0 w-full max-w-sm h-full bg-cream shadow-2xl transition-transform duration-300 transform ${sideNav ? 'translate-x-0' : 'translate-x-full'} overflow-y-auto`}>
          <div className="p-8">
            <div className='flex justify-between items-center mb-8'>
              <div className="flex items-center gap-3">
                <img src="/logo.jpeg" className='w-[44px]' alt="Logo" />
                <h3 className="font-serif text-lg font-medium text-crimson leading-tight m-0">Noohra</h3>
              </div>
              <button
                className="w-10 h-10 flex items-center justify-center bg-cream-dark rounded-full text-crimson hover:bg-crimson hover:text-white transition-colors"
                type="button"
                onClick={() => setSideNav(false)}
              >
                &times;
              </button>
            </div>
            
            <hr className="border-[rgba(139,26,26,0.1)] mb-8" />
            
            <div className="mb-10">
              <h3 className="font-serif text-2xl font-light text-charcoal mb-6 text-center">Contact Us</h3>
              <div className="bg-white p-6 rounded border border-cream-dark">
                <IconBoxStyle11
                  title="Phone"
                  subTitle="+234 803 873 8245"
                  iconSrc="/images/contact/icon_1.svg"
                />
                <Spacing md="20" lg="20" xl="20" />
                <IconBoxStyle11
                  title="Email"
                  subTitle="contact@nooohraservices.org"
                  iconSrc="/images/contact/icon_2.svg"
                />
                <Spacing md="20" lg="20" xl="20" />
                <IconBoxStyle11
                  title="Location"
                  subTitle="Abuja, Nigeria"
                  iconSrc="/images/contact/icon_3.svg"
                />
              </div>
            </div>

            <Newsletter />
            
            <hr className="border-[rgba(139,26,26,0.1)] my-8" />
            <SocialWidget />
          </div>
        </div>
      </div>
    </>
  );
}
